import { BaseAPI } from './BaseAPI';
import { Dec, ValConsAddress, ValConsPubKey } from '../../../core';

export interface SlashingParams {
  max_evidence_age: number;
  signed_blocks_window: number;
  min_signed_per_window: Dec;
  downtime_jail_duration: number;
  slash_fraction_double_sign: Dec;
  slash_fraction_downtime: Dec;
}

export namespace SlashingParams {
  export interface Data {
    max_evidence_age: string;
    signed_blocks_window: string;
    min_signed_per_window: string;
    downtime_jail_duration: string;
    slash_fraction_double_sign: string;
    slash_fraction_downtime: string;
  }
}

export interface SigningInfo {
  address: ValConsAddress;
  start_height: number;
  index_offset: number;
  jailed_until: Date;
  tombstoned: boolean;
  missed_blocks_counter: number;
}

export namespace SigningInfo {
  export interface Data {
    address: string;
    start_height: string;
    index_offset: string;
    jailed_until: string;
    tombstoned: boolean;
    missed_blocks_counter: string;
  }
}

export class SlashingAPI extends BaseAPI {
  public async signingInfos(
    valConsPubKey?: ValConsPubKey
  ): Promise<SigningInfo[]> {
    let url;
    if (valConsPubKey !== undefined) {
      url = `/slashing/validators/${valConsPubKey}/signing_info`;
    } else {
      url = `/slashing/signing_infos`;
    }

    return this.c.get<SigningInfo.Data[]>(url).then(d =>
      d.result.map(x => ({
        address: x.address,
        start_height: Number.parseInt(x.start_height),
        index_offset: Number.parseInt(x.index_offset),
        jailed_until: new Date(x.jailed_until),
        tombstoned: x.tombstoned,
        missed_blocks_counter: Number.parseInt(x.missed_blocks_counter),
      }))
    );
  }

  public async parameters(): Promise<SlashingParams> {
    return this.c
      .get<SlashingParams.Data>(`/slashing/parameters`)
      .then(d => d.result)
      .then(d => ({
        max_evidence_age: Number.parseInt(d.max_evidence_age),
        signed_blocks_window: Number.parseInt(d.signed_blocks_window),
        min_signed_per_window: new Dec(d.min_signed_per_window),
        downtime_jail_duration: Number.parseInt(d.downtime_jail_duration),
        slash_fraction_double_sign: new Dec(d.slash_fraction_double_sign),
        slash_fraction_downtime: new Dec(d.slash_fraction_downtime),
      }));
  }
}
